import React from 'react'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import { useState } from 'react';
const RequestcallForm = () => {
  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
  };
  return (
    <div>
        <Card className='rounded p-4 mt-4' style={{backgroundColor:'#EBF2F7', border:'1px solid #025EA9'}}> 
      <p>All fields are mandatory.</p>
  <Form noValidate validated={validated} onSubmit={handleSubmit}>
  <Form.Group className="mb-3" controlId="formBasicPassword">
       
        <Form.Control type="text" placeholder="Company Name *" className='input-field' required/>
        <Form.Control.Feedback type="invalid">
            Please provide a valid Company Name.
          </Form.Control.Feedback>
      </Form.Group>
      <Form.Group className="mb-3" controlId="formBasicEmail">
      
        <Form.Control type="text" placeholder="First Name *" className='input-field' required/>
        <Form.Control.Feedback type="invalid">
            Please provide a First Name.
          </Form.Control.Feedback>
        </Form.Group>
      <Form.Group className="mb-3" controlId="formBasicPassword">
        
        <Form.Control type="text" placeholder=" Last Name *" className='input-field' required/>
        <Form.Control.Feedback type="invalid">
            Please provide a Last Name.
          </Form.Control.Feedback>
      </Form.Group>
      <Form.Group className="mb-3" controlId="formBasicPassword">
      
        <Form.Control type="email" placeholder="Email *" className='input-field' required/>
        <Form.Control.Feedback type="invalid">
            Please provide a valid Email.
          </Form.Control.Feedback>
      </Form.Group>
      <Form.Group className="mb-3" controlId="formBasicPassword">
        
        <Form.Control type="text" placeholder="Phone Number *" className='input-field' required/>
        <Form.Control.Feedback type="invalid">
            Please provide a valid Phone Number.
          </Form.Control.Feedback>
      </Form.Group>
     
      <Form.Group className="mb-3" controlId="formBasicPassword">
       
        <Form.Control type="text" placeholder="Country *" className='input-field' required/>
        <Form.Control.Feedback type="invalid">
            Please provide a valid Country.
          </Form.Control.Feedback>
      </Form.Group>

      <Form.Group className="mb-3" controlId="formBasicPassword">
       
       <Form.Control type="text" placeholder="State *" className='input-field' required/>
       <Form.Control.Feedback type="invalid">
           Please provide a valid State.
         </Form.Control.Feedback>
     </Form.Group>
     <Form.Group className="mb-3" controlId="formBasicPassword">
       
       <Form.Control type="text" placeholder="Role / Title *" className='input-field' required/>
       <Form.Control.Feedback type="invalid">
           Please provide a valid Role / Title.
         </Form.Control.Feedback>
     </Form.Group>
   
      <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">

        <Form.Control as="textarea" className='input-field' rows={5} placeholder='Message *'required/>
        <Form.Control.Feedback type="invalid">
            Please provide a Description.
          </Form.Control.Feedback>
      </Form.Group>
      <div className='d-flex justify-content-center'>
      <button  type="submit" className='rounded-button'>
        Submit <i class="bi bi-arrow-right"></i>
      </button>
      </div>
    </Form>
    </Card>
    </div>
  )
}

export default RequestcallForm